import axiosInstance from '../api/axios';

const GetDataEvolutivo = async (
    username,
    token,
    studyName,
    waveName,
    lineName,
    selectedVagasEvolutivo,
    filters
) => {
    const safeSelectedVagasEvolutivo = selectedVagasEvolutivo || [];
    const safeFilters = filters || [];

    const JSONVagasEvolutivo = JSON.stringify(safeSelectedVagasEvolutivo);
    const JSONselectedFilters = JSON.stringify(safeFilters);

    console.log("[GetDataEvolutivo] payload:", {
        username,
        studyName,
        waveName,
        lineName,
        selectedVagasEvolutivo: safeSelectedVagasEvolutivo,
        filters: safeFilters,
        JSONVagasEvolutivo,
        JSONselectedFilters
    });

    try {
        const response = await axiosInstance.post(
            "/tables/getdataevolutivo",
            {},
            {
                params: {
                    username,
                    token,
                    studyName,
                    waveName,
                    lineName,
                    JSONVagasEvolutivo,
                    JSONselectedFilters
                }
            }
        );

        return response.data;

    } catch (err) {
        console.error("ERRO [Tables, GetDataEvolutivo]: Falha ao obter resultados da operação.", err);

        if (!err?.response) {
            alert("Falha de comunicação com o servidor ao obter os resultados. Por favor, contate o serviço técnico da DATA E.");
        }

        return null;
    }
};

export default GetDataEvolutivo;